// extracted by mini-css-extract-plugin
module.exports = {"baseCard":"BaseCard_baseCard___QNgz","iconWrapper":"BaseCard_iconWrapper__2eNg8","cardIcon":"BaseCard_cardIcon__13BI0","cardText":"BaseCard_cardText__2DEj7"};